var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closePopup,
          expression: "closePopup",
        },
      ],
      staticClass: "DateFilter filterWrapper",
      class: { open: _vm.popupOpen },
    },
    [
      _c("div", { staticClass: "lgrid-noGutter-noWrap title-wrapper" }, [
        _c("div", [
          _c(
            "button",
            {
              staticClass: "title",
              class: { active: _vm.isActive },
              on: { click: _vm.openPopup },
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.placeholder) } })]
          ),
        ]),
        _c("div", { staticClass: "person-count--wrapper" }, [
          _c(
            "button",
            {
              staticClass: "title person-count",
              class: { active: _vm.isActive },
              on: { click: _vm.openPersons },
            },
            [
              _c("span", [
                _c("i", { staticClass: "dsio-user-alt-solid" }),
                _vm._v(_vm._s(_vm.nbPersons)),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "filter--popup" },
        [
          _vm.popupOpen
            ? _c("date-picker", {
                attrs: {
                  placeholder: _vm.placeholder,
                  mode: _vm.mode,
                  options: _vm.conf.calendarOptions,
                  forceRange: _vm.conf.forceRange,
                },
                on: { apply: _vm.apply, close: _vm.closePopup },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("div", [
                            _c("div", { staticClass: "person-count title" }, [
                              _c("i", { staticClass: "dsio-user-alt-solid" }),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.nbPersons,
                                    expression: "nbPersons",
                                  },
                                ],
                                ref: "persons",
                                staticClass: "person-count-input",
                                attrs: {
                                  width: "50",
                                  type: "number",
                                  min: _vm.personsMin,
                                  max: _vm.personsMax,
                                },
                                domProps: { value: _vm.nbPersons },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.nbPersons = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1387538317
                ),
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }